import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=05bf8309&scoped=true&"
import script from "./examination.js?vue&type=script&lang=js&"
export * from "./examination.js?vue&type=script&lang=js&"
import style0 from "./examination.css?vue&type=style&index=0&id=05bf8309&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf8309",
  null
  
)

export default component.exports